export const ROUTE_JOBS = '/'
export const ROUTE_JOB_DETAIL = '/jobs/:job_id'
export const ROUTE_REQUISITION = '/requisitions/new'
export const ROUTE_REQUISITION_LIST = '/admin/requisitions'
export const ROUTE_REQUISITION_DETAIL = '/admin/requisition/detail/:id'
export const ROUTE_ADMIN = '/admin'
export const ROUTE_ADMIN_MAIN = "/jobportaladmin"
export const ROUTE_ADMIN_LOGIN = '/admin/login'
export const ROUTE_ADMIN_CV = '/admin/cv'
export const ROUTE_ADMIN_CV_DETAIL = '/admin/cvs/:id'
export const ROUTE_ADMIN_JOB = '/admin/jobs'
export const ROUTE_ADMIN_JOB_DETAIL = '/admin/job/detail/:id'
export const ROUTE_ADMIN_CREATE_JOB = '/admin/job/create'